import React from "react";
import { Flex, Text, Skeleton } from "@chakra-ui/react";
import Card from "components/card/Card";
import { isNull } from "lodash";

interface ProjectMetaInfoProps {
  projectMeta: Array<{
    label: string;
    value: any;
  }>;
  isFetching: boolean;
}

export const ProjectMetaInfo: React.FC<ProjectMetaInfoProps> = ({
  projectMeta,
  isFetching,
}) => {
  return (
    <Flex
      marginTop={{ md: "36px", base: "20px" }}
      columnGap={{ md: "36px", base: "15px" }}
      wrap="wrap"
      rowGap="20px"
    >
      {projectMeta
        ?.filter((it: any) => !isNull(it?.value))
        ?.map((it: any, index: number) => (
          <Card p="0" w="fit-content" key={index}>
            <Text
              fontWeight="400"
              fontSize="12px"
              lineHeight="24px"
              color="#8E8C8C"
            >
              {it.label}
            </Text>

            {isFetching ? (
              <Skeleton height="25px" width="70px"></Skeleton>
            ) : (
              <Text
                marginTop="5px"
                fontWeight="400"
                fontSize={{ md: "17px", sm: "14px" }}
                lineHeight="135%"
                color="#000"
                textTransform="capitalize"
                whiteSpace={
                  it?.label === "Address" ? "pre" : "normal"
                }
              >
                {it.value}
              </Text>
            )}
          </Card>
        ))}
    </Flex>
  );
};
